"use client";

import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDict } from "@/lib/i18n/context";

export function CopyLink({ link }: { link: string }) {
  const t = useDict();
  const [copied, setCopied] = useState(false);
  return (
    <div className="flex items-center gap-2 rounded-xl border border-border bg-surface p-2">
      <span className="flex-1 truncate px-2 text-sm">{link}</span>
      <Button
        size="sm"
        variant="outline"
        onClick={() => {
          navigator.clipboard.writeText(link);
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        }}
      >
        {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
        {copied ? t.common.copied : t.common.copy}
      </Button>
    </div>
  );
}
